import { styled } from 'goober';

export const Wrapper = styled('div')`
    display: flex;
    height: 100%;
    margin-right: 20px;
    padding: 20px 0;
`;

export const MainView = styled('div')`
    display: flex;
    width: 76.06%;
    height: 100%;
    flex-shrink: 0;
    gap: 20px;
    flex-direction: column;
    padding: 0 20px;
`;

export const SideView = styled('div')`
    height: 100%;
    flex-grow: 1;
`;
